import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { UserConfig } from './user-service.types';

export function provideUserService(config: UserConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: 'UserConfig', useValue: config }
  ]);
}
